export function formatDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return String(dateString);

  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  return new Intl.DateTimeFormat("en-US", options).format(date);
}

/** Format API time ("13:31:00") for display, e.g. "1:31 PM". */
export function formatScheduleTime(timeString) {
  if (!timeString) return "";
  const raw = String(timeString).trim();
  const match = raw.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!match) return raw;

  const date = new Date();
  date.setHours(Number(match[1]), Number(match[2]), 0, 0);
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
}

/** Normalize time for booking / TimeOnly.Parse ("13:31:00"). */
export function toBookingTime(timeString) {
  if (!timeString) return null;
  const raw = String(timeString).trim();
  const match = raw.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!match) return raw;
  const hh = String(match[1]).padStart(2, "0");
  const mm = String(match[2]).padStart(2, "0");
  const ss = String(match[3] || "0").padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}

export const getEventSchedules = (event) => {
  const list = event?.Schedules || event?.schedules || [];
  return Array.isArray(list) ? list : [];
};

export const getOneMonthAgo = (dateString) => {
  const date = new Date(dateString);

  date.setMonth(date.getMonth() - 1);

  const formattedDate = `${date.toLocaleString("default", {
    month: "long",
  })} ${date.getFullYear()}`;

  return formattedDate;
};